export const RegistracijaKompanijeResourcesDE: RegistracijaKompanijeResourcesBSInterface =
  {
    dupplicateError:
      "Hinzufügen fehlgeschlagen, eingegebene Daten sind dupliziert",
    izmjenaPoslovnice: {
      title: "Filialdaten bearbeiten",
      next: "Speichern",
      back: "Zurück",
      dialogSuccess: {
        title: "Erfolgreich!",
        body: "Sie haben die Filialdaten erfolgreich geändert!",
        buttonOk: "OK",
      },
      errorLoading:
        "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
      errorUpdate:
        "Filialaktualisierung fehlgeschlagen. Bitte kontaktieren Sie den Administrator.",
    },
    izmjenaKompanije: {
      title: "Unternehmensdaten bearbeiten",
      next: "Speichern",
      back: "Zurück",
      dialogSuccess: {
        title: "Erfolgreich!",
        body: "Sie haben die Unternehmensdaten erfolgreich geändert!",
        buttonOk: "OK",
      },
      errorLoading:
        "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
      errorUpdate:
        "Unternehmensaktualisierung fehlgeschlagen. Bitte kontaktieren Sie den Administrator.",
    },
    odabirKompanije: {
      title: "Unternehmen",
      dropdownLabel: "Unternehmen auswählen:",
      dropdownPlaceholder: "Unternehmen auswählen",
      dropdownNoOptionsMessage: "Keine Unternehmen eingegeben",
      addCompanyButton: "Neues Unternehmen hinzufügen",
      editCompanyButton: "Unternehmen bearbeiten",
      next: "Auswählen",
      back: "Zurück",
      errorLoading:
        "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
    },
    odabirPoslovnice: {
      title: "Filialen",
      dropdownLabel: "Filiale auswählen:",
      dropdownPlaceholder: "Filiale auswählen",
      dropdownNoOptionsMessage: "Keine Filialen eingegeben",
      addCompanyButton: "Neue Filiale hinzufügen",
      next: "Bearbeiten",
      back: "Zurück",
      errorLoading:
        "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
    },
    dodavanjeKompanije: {
      title: "Unternehmen hinzufügen",
      formButton: "Speichern",
      next: "Weiter",
      back: "Zurück",
      companyName: {
        label: "Unternehmensname",
        name: "companyName",
        error: "Sie haben keinen Unternehmensnamen eingegeben",
      },
      street: {
        label: "Straße und Nummer",
        name: "street",
        error: "Sie haben keine Straße eingegeben",
      },
      city: {
        label: "Stadt",
        name: "city",
        error: "Sie haben keine Stadt eingegeben",
      },
      zipCode: {
        label: "Postleitzahl",
        name: "zipCode",
        error: "Sie haben keine Postleitzahl eingegeben",
        validation: "Ungültige Nummer",
      },
      country: {
        label: "Land",
        name: "country",
        error: "Sie haben kein Land eingegeben",
      },
      email: {
        label: "E-Mail",
        name: "email",
        error: "Sie haben keine E-Mail eingegeben",
        validation: "Sie haben keine gültige E-Mail eingegeben",
      },
      phone: {
        label: "Telefon",
        name: "phone",
        error: "Sie haben kein Telefon eingegeben",
        validation: "Ungültige Nummer",
      },
      idCompanyNumber: {
        label: "ID-Nummer",
        name: "idCompanyNumber",
        error: "Sie haben keine ID-Nummer eingegeben",
        validation: "Ungültige Nummer",
      },
      vatCompanyNumber: {
        label: "USt-Nummer",
        name: "vatCompanyNumber",
        error: "Sie haben keine USt-Nummer eingegeben",
        validation: "Ungültige Nummer",
      },
      contactPerson: {
        label: "Kontaktperson",
        name: "contactPerson",
        error: "Sie haben keine Kontaktperson eingegeben",
      },
      saleRepresentative: {
        label: "Vertriebsmitarbeiter",
        name: "saleRepresentative",
        error: "Sie haben keinen Vertriebsmitarbeiter eingegeben",
      },
      salesPersonDropdown: {
        label: "Vertriebsmitarbeiter auswählen (optional)",
        placeholder: "Vertriebsmitarbeiter auswählen",
        noOptions: "Keine Vertriebsmitarbeiter verfügbar",
      },
      chiefUsersDropdown: {
        label: "Firmenchefs auswählen (optional)",
        placeholder: "Firmenchefs auswählen",
        noOptions: "Keine Benutzer verfügbar",
      },
      managerUsersDropdown: {
        label: "Filialmanager auswählen (optional)",
        placeholder: "Filialmanager auswählen",
        noOptions: "Keine Benutzer verfügbar",
      },
      branchName: {
        label: "Filialname",
        name: "branchName",
        error: "Sie haben keinen Filialnamen eingegeben",
      },
      dialogSuccess: {
        title: "Erfolgreich!",
        body: "Sie haben das Unternehmen zur Datenbank hinzugefügt!",
        buttonOk: "OK",
      },
    },
    dodavanjePoslovnice: {
      title: "Filiale hinzufügen",
      type: "Objekttyp",
      name: "objectType",
      error: "Sie haben keine Filiale ausgewählt",
      options: [
        {
          value: "",
          label: "Bitte wählen Sie den Objekttyp aus",
        },
        {
          value: "Punionica meda",
          label: "Honigabfüllstation",
        },
        {
          value: "Ugostiteljski objekat",
          label: "Gastronomieeinrichtung",
        },
        {
          value: "Pekara",
          label: "Bäckerei",
        },
        {
          value: "Apoteka",
          label: "Apotheke",
        },
        {
          value: "Hotel",
          label: "Hotel",
        },
      ],
      dialogSuccess: {
        title: "Erfolgreich!",
        body: "Sie haben die Filiale zur Datenbank hinzugefügt!",
        buttonOk: "OK",
      },
    },
  };

export interface RegistracijaKompanijeResourcesBSInterface {
  dupplicateError: string;
  izmjenaPoslovnice: {
    title: string;
    next: string;
    back: string;
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
    errorLoading: string;
    errorUpdate: string;
  };
  izmjenaKompanije: {
    title: string;
    next: string;
    back: string;
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
    errorLoading: string;
    errorUpdate: string;
  };
  odabirKompanije: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    editCompanyButton: string;
    errorLoading: string;
    next: string;
    back: string;
  };
  odabirPoslovnice: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
    errorLoading: string;
  };
  dodavanjeKompanije: {
    title: string;
    formButton: string;
    next: string;
    back: string;
    companyName: {
      label: string;
      name: string;
      error: string;
    };
    street: {
      label: string;
      name: string;
      error: string;
    };
    city: {
      label: string;
      name: string;
      error: string;
    };
    zipCode: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    country: {
      label: string;
      name: string;
      error: string;
    };
    email: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    phone: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    idCompanyNumber: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    vatCompanyNumber: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    contactPerson: {
      label: string;
      name: string;
      error: string;
    };
    saleRepresentative: {
      label: string;
      name: string;
      error: string;
    };
    salesPersonDropdown: {
      label: string;
      placeholder: string;
      noOptions: string;
    };
    chiefUsersDropdown: {
      label: string;
      placeholder: string;
      noOptions: string;
    };
    managerUsersDropdown: {
      label: string;
      placeholder: string;
      noOptions: string;
    };
    branchName: {
      label: string;
      name: string;
      error: string;
    };
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
  };
  dodavanjePoslovnice: {
    title: string;
    type: string;
    name: string;
    error: string;
    options: {
      value: string;
      label: string;
    }[];
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
  };
}
